"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilter = void 0;
var tslib_1 = require("tslib");
var AdvancedFilter_1 = require("./AdvancedFilter");
var DateFilter = /** @class */ (function (_super) {
    tslib_1.__extends(DateFilter, _super);
    function DateFilter(fields) {
        var _this = _super.call(this) || this;
        if (typeof fields === 'object') {
            Object.assign(_this, fields);
        }
        return _this;
    }
    return DateFilter;
}(AdvancedFilter_1.AdvancedFilter));
exports.DateFilter = DateFilter;
//# sourceMappingURL=DateFilter.js.map